import watchos from '@/assets/device-icons/watchos.svg';

interface WatchosIconProps {
  className?: string;
}

export const WatchosIcon = ({ className = "h-5 w-5" }: WatchosIconProps) => {
  return (
    <img 
      src={watchos} 
      alt="watchOS" 
      className={className}
    />
  );
};
